import {DateTime} from 'luxon';
import React, {memo} from 'react';

interface Props {
  date: string;
}

export const DateComponent: React.FC<Props> = memo(({date}) => <>{DateTime.fromISO(date).setZone('Europe/Amsterdam').setLocale('nl').toFormat('ccc d-L-yyyy')}</>);
